'use client';
import { PAGE_PATHS } from '@/constants/constants';
import { Button, CardContent, Chip, Divider, Typography } from '@mui/material';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import React from 'react';

type featureInclusion = {
  included: boolean;
  name: string;
};

type SubscriptionCardProps = {
  name: string;
  description: string;
  features: featureInclusion[];
  price: string | React.ReactNode;
  priceLabel: string;
  best: boolean;
  ctaLink?: string;
  ctaText?: string;
};

export const SubscriptionDetailsCard = ({
  name,
  description,
  features,
  price,
  priceLabel,
  best,
  ctaLink,
  ctaText
}: SubscriptionCardProps) => {
  const searchParams = useSearchParams();

  const nextParam = searchParams.get('next') || undefined;

  return (
    <CardContent
      style={{
        padding: '16px 20px',
        height: '100%',
        gap: 0
      }}
    >
      <div className='product-title'>
        <h3>{name}</h3>
        {best ? (
          <Chip
            sx={{ borderRadius: 2, fontWeight: 500, fontSize: '14px' }}
            color='primary'
            label='Best Value'
          />
        ) : null}
      </div>
      <h3 className='price'>{price}</h3>
      <Typography variant='body2' sx={{ marginBottom: '20px' }}>
        {priceLabel}
      </Typography>
      <Divider />
      <Button
        variant='contained'
        disableElevation
        LinkComponent={Link}
        href={
          ctaLink
            ? ctaLink
            : `${PAGE_PATHS.signup}?product=${encodeURIComponent(name)}${nextParam ? `&next=${encodeURIComponent(nextParam)}` : ''}`
        }
        sx={{ marginY: '15px' }}
      >
        {ctaText ? ctaText : `Choose ${name}`}
      </Button>
      <Divider />
      <h3>inclusions</h3>
      <ul>
        {features.map((feature, index) => (
          <li
            key={index}
            style={{
              textDecoration: feature.included ? undefined : 'line-through'
            }}
          >
            {feature.name}
          </li>
        ))}
      </ul>
      <Divider />
      <div
        className='product-description'
        style={{ marginTop: '20px', flexGrow: 1, alignContent: 'flex-end' }}
      >
        <p color='text.secondary' style={{ minHeight: '100px' }}>
          {description}
        </p>
      </div>
    </CardContent>
  );
};
